import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cn from 'classnames';

import { DATA_TEST_ID } from '~constants/tests';
import AuthActions from '~redux/Auth/actions';

import styles from './styles.module.scss';

const LogoutButton = () => {
  const { currentUser } = useSelector((state) => state.auth);
  const isSecondaryHeader = useSelector((state) => state.core.settings?.secondaryHeader);
  const dispatch = useDispatch();
  const closeSession = () => dispatch(AuthActions.closeSession());
  return (
    currentUser && (
      <button
        data-testid={DATA_TEST_ID.logout}
        onClick={closeSession}
        type="button"
        className={cn('m-right-2', styles.logoutButton, {
          [styles.secondaryHeader]: isSecondaryHeader
        })}>
        <span className={`material-icons-outlined ${styles.iconLogout}`}>logout</span>
      </button>
    )
  );
};

export default LogoutButton;
